/* eslint max-len: "off" */
import React from 'react';
import {
  SortableContainer,
  SortableElement,
  arrayMove,
} from 'react-sortable-hoc';
import { withOptionItems, Label } from './byob-cms';

const MoveIconElement = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 64 64"
    enableBackground="new 0 0 64 64"
  >
    <g>
      <path
        fill="#1D1D1B"
        d="m63.875,31.203c-0.102-0.246-0.248-0.467-0.435-0.652l-6.837-6.838c-0.783-0.783-2.051-0.783-2.834,0-0.781,0.781-0.781,2.05 0,2.832l3.42,3.42-23.16-.001 .002-23.155 3.568,3.57c0.393,0.392 0.904,0.588 1.418,0.588 0.512,0 1.025-0.196 1.416-0.588 0.783-0.781 0.783-2.051 0-2.834l-6.988-6.99c-0.186-0.186-0.406-0.332-0.652-0.434-0.49-0.203-1.041-0.203-1.531,0-0.244,0.101-0.463,0.246-0.646,0.429 0,0-0.002,0.002-0.004,0.003l-6.844,6.84c-0.781,0.783-0.781,2.051 0,2.834 0.393,0.391 0.904,0.587 1.418,0.587 0.512,0 1.025-0.196 1.416-0.587l3.422-3.42-.002,23.157-23.15-.001 3.417-3.418c0.781-0.782 0.781-2.051 0-2.832-0.783-0.783-2.051-0.783-2.834,0l-6.838,6.84c-0.393,0.391-0.588,0.903-0.588,1.416s0.195,1.025 0.588,1.417l6.988,6.989c0.392,0.393 0.904,0.588 1.417,0.588s1.025-0.195 1.417-0.588c0.782-0.783 0.782-2.051 0-2.833l-3.571-3.571 23.153,.001-.001,23.153-3.418-3.417c-0.783-0.78-2.051-0.782-2.834,0.001-0.781,0.783-0.781,2.052 0,2.834l6.844,6.839c0.391,0.392 0.904,0.587 1.416,0.587 0.513,0 1.025-0.195 1.416-0.587l6.99-6.991c0.783-0.783 0.783-2.053 0-2.834-0.783-0.783-2.051-0.783-2.834,0l-3.572,3.574 .002-23.159 23.16,.001-3.57,3.569c-0.781,0.782-0.781,2.05 0,2.833 0.393,0.393 0.904,0.588 1.418,0.588 0.512,0 1.025-0.195 1.416-0.588l6.989-6.989c0.004-0.005 0.006-0.012 0.012-0.017 0.177-0.182 0.321-0.396 0.421-0.633 0.102-0.246 0.154-0.506 0.154-0.768-0.001-0.259-0.053-0.52-0.155-0.765z"
      />
    </g>
  </svg>
);

const SortableItem = SortableElement(({ value }) => (
  <li className="list-group-item">
    <MoveIconElement />
    &nbsp;
    {value}
  </li>
));

const SortableList = SortableContainer(({ items }) => (
  <ul className="list-group" style={{ cursor: 'pointer' }}>
    {items.map((item, index) => (
      <SortableItem key={item.value} index={index} value={item.label} />
    ))}
  </ul>
));

function SortableField(props) {
  const {
    schema,
    idSchema,
    uiSchema,
    name,
    required,
    optionItems,
    onChange,
    formData,
  } = props;

  const items = formData
    .filter(
      value => !!optionItems.find(optionItem => optionItem.value === value),
    )
    .map(value => ({
      label: optionItems.find(optionItem => optionItem.value === value).label,
      value,
    }));

  function onSortEnd({ oldIndex, newIndex }) {
    onChange(arrayMove(formData, oldIndex, newIndex));
  }

  const label = uiSchema['ui:title'] || schema.title || name;
  const id = idSchema.$id;

  return (
    <div>
      <Label label={label} required={required} id={id} />
      <SortableList items={items} onSortEnd={onSortEnd} />
    </div>
  );
}

export default withOptionItems(SortableField, 'field');



// WEBPACK FOOTER //
// ./src/SortableField.js